import { render } from "./module.vue?vue&type=template&id=325cefb0"
import script from "./module.vue?vue&type=script&lang=js"
export * from "./module.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"dev/modules/theme/gallery-case-studies/module.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "325cefb0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('325cefb0', __exports__)) {
    api.reload('325cefb0', __exports__)
  }
  
  module.hot.accept("./module.vue?vue&type=template&id=325cefb0", () => {
    api.rerender('325cefb0', render)
  })

}


export default __exports__